import { registerLocaleData } from '@angular/common';

import localePl from '@angular/common/locales/pl';
import localeEsUs from '@angular/common/locales/es-US';

(function () {
  registerLocaleData(localeEsUs);
  registerLocaleData(localePl);
})();
